"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PaginacionConfig = {

  CANTIDAD_REGISTROS: 10,
  CANTIDAD_REGISTROS_FACETA: 5,
  MAXIMO_PAGINAS: 4
};

exports.default = PaginacionConfig;


// WEBPACK FOOTER //
// ./src/busqueda/config/paginacion.config.js